import angular from 'angular';
import {
  loaderService,
  orgDataService,
  userService,
} from 'app/services';
import {
  alerts,
  importDocument,
  actionIcon,
  sorting
} from 'app/components/global';
import releaseNotes from './releaseNotes';
import ReleaseProductController from './release-product.controller';
import directive from './release-product.directive';

export const routeConfig = {
  template: require('./release-product.html'),
  controller: 'ReleaseProductController',
  controllerAs: 'releaseProductVM',
};

export default angular.module('app.components.support.releaseProduct', [
  alerts,
  actionIcon,
  importDocument,
  loaderService,
  orgDataService,
  userService,
  releaseNotes,
  sorting
])
  .directive('releaseProduct', directive)
  .controller('ReleaseProductController', ReleaseProductController)
  .name;

console.log('app.components.support.releaseProduct created');
